export class FlightConnections {
  public draw = (
    gl: CanvasRenderingContext2D,
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    color: string,
    index: number
  ): void => {
    //do we need to offset?
    const offset = index % 2 === 0 ? 4 * index : -(index * 4);

    //draw dashed lines to indicate a problem
    const warning = x1 > x2;
    gl.save();
    if (warning) {
      gl.setLineDash([5, 15]);
    }
    gl.strokeStyle = color;
    gl.beginPath();
    gl.moveTo(x1, y1 + offset);
    gl.lineWidth = 2;
    gl.lineTo(x2, y2 + offset);
    gl.stroke();
    gl.restore();
  };
}
